
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDNYB2Kx2A_w--sLFymk-CVEtgFIRrSduw",
  authDomain: "sotak101.firebaseapp.com",
  projectId: "sotak101",
  storageBucket: "sotak101.firebasestorage.app",
  messagingSenderId: "967970657940",
  appId: "1:967970657940:web:2ec67bc74b705c5dd44681",
  measurementId: "G-XHNJ4QK6PK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, analytics, auth, db, storage };
